import { PaymentMethod } from "@/constants/PaymentConstants";

export const TAX_PAYMENT_METHODS: readonly PaymentMethod[] = [
  PaymentMethod.SUBLIME_WALLET,
  PaymentMethod.CUSTOMER_CARD,
  PaymentMethod.CUSTOMER_ACCOUNT,
  PaymentMethod.CUSTOMER_BUSINESS_ACCOUNT,
  PaymentMethod.CUSTOMER_PERSONAL_ACCOUNT,
];
